import { checkErrorDniFormat, unFormatDNI } from '@chilecompra/react-kit/utils'
import { CLEAN_DNI } from '../../config/settings/regexes'

/**
 * To check if a DNI corresponds to a natural person or not.
 * This implementation is momentary.
 */
export const checkIsNaturalPerson = value => {
  const cleanValue = unFormatDNI(value?.toString())
  const dni = cleanValue.substring(0, cleanValue.length - 1)

  return parseInt(dni, 10) < 50000000
}

/**
 * To check if the given value corresponds to a foreign seller.
 */
export const checkIfForeignDni = value => !checkErrorDniFormat(value)

/**
 * To clean a value that is formatted as a Chilean DNI.
 * Returns the given value without points and hyphen.
 */
export const cleanDNI = value => {
  return typeof value === 'string' ? value.replace(CLEAN_DNI, '').toUpperCase() : ''
}

/**
 * To check if a DNI corresponds to a natural person or not.
 * This implementation is momentary.
 */
export const isNaturalPerson = value => {
  value = cleanDNI(value?.toString())
  const dni = value.substring(0, value.length - 1)

  return parseInt(dni, 10) < 50000000
}

/**
  To map the properties of an object to new properties.
 */

export const renameProperties = (obj, mappings) => {
  return Object.keys(obj).reduce((acc, key) => {
    const newKey = mappings[key] || key
    acc[newKey] = obj[key]
    return acc
  }, {})
}
